import { positionSpotlight, removeSpotlight } from "./spotlight-utils"

const SPOTLIGHT_ID = "ft-spotlight"

// Persisting "seen" must live on window, not in the hook: the server clears
// the tutorial overlay in the same render that pushes this event, so a
// hook-scoped handleEvent listener is destroyed (and its listener removed)
// before the event is dispatched — the write would be silently lost.
window.addEventListener("phx:mark_feature_tutorial_seen", (e) => {
  const tutorialId = e.detail && e.detail.tutorial_id
  if (!tutorialId) return
  try {
    const seen = JSON.parse(localStorage.getItem("feature_tutorials_seen") || "[]")
    if (!seen.includes(tutorialId)) {
      seen.push(tutorialId)
      localStorage.setItem("feature_tutorials_seen", JSON.stringify(seen))
    }
  } catch (_) {}
})

export default {
  mounted() {
    this._onResize = () => this.position()
    window.addEventListener("resize", this._onResize)

    // The overlay mounts invisible. Decide its fate from localStorage before
    // it ever paints: already seen (anonymous users) → dismiss while still
    // hidden, no flash; otherwise ask the server to reveal it. The server
    // owns the `invisible` class so DOM patches can't resurrect it.
    let seen = []
    try {
      seen = JSON.parse(localStorage.getItem("feature_tutorials_seen") || "[]")
    } catch (_) {}

    if (seen.includes(this.el.dataset.tutorialId)) {
      this.pushEvent("feature_tutorial_dismiss", {})
    } else {
      this.pushEvent("feature_tutorial_reveal", {})
    }

    this.position()
  },
  updated() {
    this.position()
  },
  destroyed() {
    window.removeEventListener("resize", this._onResize)
    removeSpotlight(SPOTLIGHT_ID)
  },
  position() {
    positionSpotlight(this.el, {
      cardId: "ft-card",
      backdropId: "ft-backdrop",
      spotlightId: SPOTLIGHT_ID,
      defaultOpacity: 0.35,
      pad: 8,
      gap: 12,
      borderRadius: "8px"
    })
  }
}
